const universityDataTable = [
    {
        id: 1,
        universityId: 'UNI-000056',
        universityDetails: [
            {
                image: 'https://campusdegrees3.s3.ap-south-1.amazonaws.com/public/undefined/9af8e486-93f2-414d-b86c-1fac2b05117c.png',
                name: 'Christ University'
            }
        ],
        courseCount: '4',
        specializationCount: '36',
        live: 'live',
        status: 'Deactivated',
        tag: 'Trending',
        enrollment: 'Closes',
        footersss: 'footerss',
        homepage: 'Home',
        action: 'Action',
        createdDate: '09/02/2025',
        lastUpdate: '09/03/2025',
        email: 'demo@gmail.com',
        phone: '+91 9968675566',
        studentHelp: '180018001800',
        shortName: 'Amity',
        website: 'Website',
        foundedYear: 'Founded Year',
    },

    {
        id: 2,
        universityId: 'PNI-000056',
        universityDetails: [
            {
                image: 'https://campusdegrees3.s3.ap-south-1.amazonaws.com/public/undefined/9af8e486-93f2-414d-b86c-1fac2b05117c.png',
                name: 'Amity University'
            }
        ],
        courseCount: '5',
        specializationCount: '38',
        live: 'ive',
        status: 'Live',
        tag: 'Top Rated',
        enrollment: 'Open ',
        footer: 'New Footer',
        homepage: 'New Home',
        action: 'Take Action',
        createdDate: '10/02/2025',
        lastUpdate: '01/03/2025',
        email: 'person@gmail.com',
        phone: '+91 9168675566',
        studentHelp: '190018001800  '
    },
    {
        id: 3,
        universityId: 'PNI-000056',
        universityDetails: [
            {
                image: 'https://campusdegrees3.s3.ap-south-1.amazonaws.com/public/undefined/9af8e486-93f2-414d-b86c-1fac2b05117c.png',
                name: 'Sharda University'
            }
        ],
        courseCount: '5',
        specializationCount: '38',
        live: 'Live',
        status: 'Live',
        tag: 'High Demand',
        enrollment: 'Open ',
        footer: 'New Footer',
        homepage: 'New Home',
        action: 'Take Action',
        createdDate: '10/02/2025',
        lastUpdate: '01/03/2025',
        email: 'person@gmail.com',
        phone: '+91 9168675566',
        studentHelp: '190018001800  '
    },
]
export default universityDataTable